module.exports = __webpack_public_path__ + "img/article-header-preview-6.28db579c.jpg";